import React, { FunctionComponent, MouseEventHandler } from 'react';
import './chat-button.scss';

interface IChatButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  isVisible: boolean;
}

const ChatButton: FunctionComponent<IChatButtonProps> = ({ isVisible, ...props }): JSX.Element => (
  <button className="chat-button" {...props} style={{ display: isVisible ? 'flex' : 'none' }}/>
);

export default ChatButton;